import axios, { type AxiosInstance } from 'axios';
import { config as appConfig } from '@/config';
import { getCurrentAuthHeaders } from '@/services/api/auth-session';

export function getAIUsageClient(): AxiosInstance {
  return axios.create({
    baseURL: `${appConfig.api.baseUrl}/ai/usage`,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      ...getCurrentAuthHeaders(),
    },
  });
}

export function getHealthClient(): AxiosInstance {
  return axios.create({
    baseURL: `${appConfig.api.baseUrl}/system-health`,
    timeout: 15000,
    headers: {
      'Content-Type': 'application/json',
      ...getCurrentAuthHeaders(),
    },
  });
}

export function getApiClient(): AxiosInstance {
  return axios.create({
    baseURL: appConfig.api.baseUrl,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      ...getCurrentAuthHeaders(),
    },
  });
}
